export default "__VITE_ASSET__c5cece36__"